import { render, staticRenderFns } from "./ObjectRoomFeatures.vue?vue&type=template&id=01537879"
import script from "./ObjectRoomFeatures.vue?vue&type=script&lang=js"
export * from "./ObjectRoomFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports